module.exports = __webpack_public_path__ + "img/flecha_abajo_inactiva.158807ca.svg";